import { IModificationAutoCompleteCommonItem } from '@patsnap/synapse_common_interface'
import { IAutoCompleteParams, IModificationDetail, ISearchTreeParams, ISearchTreeResult } from '../../types'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class ModificationApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getAutocomplete(params: IAutoCompleteParams): Promise<IHttpWrap<IModificationAutoCompleteCommonItem[]>> {
    const { keywords, limit = 5, cancelToken } = params
    return this.http({
      method: 'GET',
      url: this.getUrl('discoveryls_common/1.0/modification/autocomplete'),
      params: { prefix: keywords, limit },
      cache: true,
      cancelToken,
    })
  }

  async searchTree(params: ISearchTreeParams): Promise<IHttpWrap<ISearchTreeResult>> {
    return this.http({
      url: this.getUrl('pharmsnap_webapi/1.0/modification/tree/search'),
      data: {
        ...params,
        // 用于bio那边判断只返回跟药有关的数据
        source_tag: ['Drug'],
      },
      method: 'POST',
      cache: true,
    })
  }

  async getModificationDetail(id: string): Promise<IHttpWrap<IModificationDetail>> {
    return this.http({
      method: 'GET',
      url: this.getUrl(`pharmsnap_webapi/1.0/drug/${id}/modification`),
      cache: true,
    })
  }

  async getModificationStructureImg(inchKeys: string[]): Promise<IHttpWrap<{ [key: string]: any }>> {
    return this.http({
      method: 'POST',
      data: {
        inchi_keys: inchKeys,
      },
      url: this.getUrl('pharmsnap_webapi/1.0/modification/structure-image'),
      cache: true,
    })
  }
}
